export const TableHelpers = {
    data() {
        return {
            tableColumns : [
                {
                    title: this.$t('form_name'),
                    type: 'text',
                    className: 'font-weight-bold course-name',
                    key: 'name',
                    sortable: true,

                },
                {
                    title: this.$t('course_note'),
                    type: 'custom-html',
                    key: 'note',
                    modifier: (value) => {
                        if(value){
                            return `<span v-else class="latest-comment">${value}</span>`;
                        } else {
                            return `<span v-if="row[column.key].length === 0" class="fixed-row-height"><input type="button" value="+" class="btn btn-primary btn-sm " ></span>`;
                        }
                        
                    }

                },

                {
                    title: this.$t('one_tag'),
                    type: 'custom-html',
                    key: 'label',
                    sortable: true,
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            let ClassName = 'light-silver';

                            let selected_tag = value;
                            let tag_html = '<span class="badge badge-sm badge-pill badge-light-silver" title="'+selected_tag+'">'+selected_tag+'</span>';

                            return '<div>'+tag_html+'</div>';

                        }
                    }
                },

                {
                    title: this.$t('timeline_course_date'),
                    type: 'custom-html',
                    sortable: true,
                    className: 'column-sm',
                    key: 'timeline_state',
                    isVisible: true,
                    modifier: (value) => {
                        let timelineStateName = [];
                        let currentTimelineState = [value];

                        if (value) {
                            timelineStateName = this.options.timelineState.filter( i => currentTimelineState.includes( i.id ) );
                            timelineStateName = timelineStateName[0].value;

                        }

                        return `<div>${timelineStateName}</div>`;
                    }
                },

                {
                    title: this.$t('displayed_on_onboarding_sites'),
                    type: 'custom-html',
                    className: 'column-sm',
                    key: 'status',
                    isVisible: true,
                    modifier: (value) => {
                        let StatusIcon = 'wrong';

                        if (value == '1') {
                            StatusIcon = 'perfect';

                        }

                        return `<div class="questionnaire-mark questionnaire-mark-${StatusIcon}"></div>`;
                    }
                },

                {
                    title: this.$t('date_created'),
                    type: 'custom-html',
                    sortable: true,
                    key: 'created_at',
                    isVisible: false,
                    modifier: (value) => {

                        let date = new Date(value);
                        let dateOptions = { timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit' };
                        let dateCreated = date.toLocaleString('cs-CZ', dateOptions);

                        return `${dateCreated}`;
                    }
                },

                {
                    title: this.$t('date_updated'),
                    type: 'custom-html',
                    sortable: true,
                    key: 'updated_at',
                    isVisible: false,
                    modifier: (value) => {

                        let date = new Date(value);
                        let dateOptions = { timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit' };
                        let dateUpdated = date.toLocaleString('cs-CZ', dateOptions);

                        return `${dateUpdated}`;
                    }
                },

            ],
            actionObj : {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}
